import endpoints from "@/utils/constants";
import { apiHelper, authHelper } from "@/utils/helpers";
import userUtil from "@/utils/UserUtil";
const qs = require("qs");

const actions = {
  login(context, data) {
    return new Promise((resolve, reject) => {
      const requestBody = {
        username: data.email,
        password: data.password,
        branch_id: data.branchId,
        client_id: "application",
        client_secret: "securegate",
        grant_type: "password"
      };
      fetch(`${endpoints.BASE_URL}/auth/token`, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        }),
        body: qs.stringify(requestBody)
      })
        .then(res => res.json())
        .then(body => {
          if (body.accessToken) {
            authHelper.setToken(body.accessToken);
            context.commit("updateAuthStatus", true);
            authHelper.setUser(body.user);
            context.commit("updateLoggedInUser", body.user);
            resolve(true);
          } else {
            resolve(body);
            reject(new Error("No access token."));
          }
        })
        .catch(err => {
          reject(new Error("Unable to get profile data."));
        });
    });
  },

  saveUser(context) {
    return new Promise((resolve, reject) => {
      if (context.state.user.customerTypes === null) {
        delete context.state.user.customerTypes;
      }
      apiHelper
        .call(
          "post",
          `${endpoints.BASE_URL}${endpoints.API.users}`,
          context.state.user
        )
        .then(res => {
          if (res.status === 201) {
            context.commit("resetUser");
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getUsers(context, query) {
    const url = new URL(`${endpoints.BASE_URL}${endpoints.API.users}`);
    if (query) {
      url.search = new URLSearchParams(query);
    }
    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", url)
        .then(res => {
          if (res.status === 200) {
            if (query && query.role === "Customer") {
              context.commit("setCustomerList", res.data);
            } else {
              context.commit("setUserList", res.data);
            }
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  fetchUser(context, userId) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", `${endpoints.BASE_URL}${endpoints.API.users}/${userId}`)
        .then(res => {
          if (res.status === 200 || res.status === 201) {
            context.commit("setUser", res.data);
            resolve(res.data);
          } else {
            reject(new Error("Unexpected response"));
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  updateUser(context) {
    const user = userUtil.transform(context.state.user);
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "put",
          `${endpoints.BASE_URL}${endpoints.API.users}/${context.state.user.userId}`,
          user
        )
        .then(res => {
          if (res.status === 200) {
            context.commit("setUser", res.data);
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  forgotPassword(context, userName) {
    const url = new URL(`${endpoints.BASE_URL}${endpoints.WEB.forgotPassword}`);
    const params = {
      userName: userName
    };
    url.search = new URLSearchParams(params);

    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", url)
        .then(res => {
          if (res.status === 200) {
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  changePassword(context, data) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "post",
          `${endpoints.BASE_URL}${endpoints.API.users}/${context.state.user.id}/change/password`,
          data
        )
        .then(res => {
          if (res.status === 200) {
            resolve(res);
          }
        })
        .catch(err => {
          if (err.response && err.response.data && err.response.data.message) {
            reject(err.response.data.message);
          }
        });
    });
  },

  checkNumberExist(context, params) {
    const url = new URL(
      `${endpoints.BASE_URL}${endpoints.API.users}/phone/exist`
    );
    if (params) {
      url.search = new URLSearchParams(params);
    }
    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", url)
        .then(res => {
          if (res.status === 200) {
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  saveUserQuotation(_, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call("post", `${endpoints.BASE_URL}/api/v1/user-quotations/`, payload)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getUserQuotations(context, params = {}) {
    const url = new URL(`${endpoints.BASE_URL}/api/v1/user-quotations`);
    const query = {};
    if (params.page) {
      query.page = params.page;
    }
    if (params.perPage) {
      query.perPage = params.perPage;
    }
    if (params.fromDate) {
      query.fromDate = params.fromDate;
    }
    if (params.toDate) {
      query.toDate = params.toDate;
    }
    if (params.quotationNumber) {
      query.quotationNumber = params.quotationNumber;
    }
    if (params.customerName) {
      query.customerName = params.customerName;
    }
    if (params.total) {
      query.total = params.total;
    }
    if (params.status) {
      query.status = params.status;
    }
    if (Object.keys(query).length > 0) {
      url.search = new URLSearchParams(query);
    }
    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", url)
        .then(res => {
          context.commit("setUserQuotations", res.data.rows);
          context.commit("setUserQuotationMeta", res.data.meta);
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getUserQuotation(context, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", `${endpoints.BASE_URL}/api/v1/user-quotations/${payload}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateUserQuotation(context, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "put",
          `${endpoints.BASE_URL}/api/v1/user-quotations/${payload.userQuotationId}`,
          payload
        )
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // print user quotation
  printUserQuotation(_, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "post",
          `${endpoints.PRINTER_API_URL}${endpoints.PRINT_API.quotation}`,
          payload
        )
        .then(res => {
          if (res.status === 200) {
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  updateCustomerAddress(_, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "put",
          `${endpoints.BASE_URL}/api/v1/users/address/${payload.customerAddressId}`,
          payload
        )
        .then(res => {
          if (res.status === 200) {
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getCustomerAddresses(_, userId) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", `${endpoints.BASE_URL}/api/v1/users/${userId}/addresses`)
        .then(res => {
          if (res.status === 200) {
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  searchUsers(_, params) {
    let query = new URLSearchParams();
    for (let key in params) {
      query.set(key, params[key]);
    }
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.LARAVEL_BASE_URL}/api/v1/users?${query.toString()}`
        )
        .then(res => {
          resolve(res.data.rows);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  getBranches() {
    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", `${endpoints.LARAVEL_BASE_URL}/api/v1/branches`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.response);
        });
    });
  }
};
export default actions;
